import { Drawer as MuiDrawer, DrawerProps as MuiDrawerProps } from '@mui/material';

export const Drawer = MuiDrawer;
export type DrawerProps = MuiDrawerProps;
